module.exports = __webpack_public_path__ + "static/media/white-yes.5b46843b.svg";